<div class="container">


    <div class="body">
        <button class="botonAval" mat-button routerLink="/actualizar_informacion" style="align-self: flex-end;" (click)="ActualizarInformacion()" [disabled]="ActualizoInformacion" [ngClass]="{'infoActualizada': ActualizoInformacion}">
            <span class="colorTextoAval">Actualizar Información</span>
        </button>
        <!-- <app-btn-actualizar-info ></app-btn-actualizar-info> -->
        <br>
        <div class="alert alert-danger" role="alert" *ngIf="!Referencias[0].lo_recomienda1">
            Se necesita actualizar la información de las Referencias
          </div>
        <div class="alert alert-danger" role="alert" *ngIf="!documentosCompletos">
            Es necesario cargar y/o validar todos los documentos
          </div>
          <br>
        <div class="row">
            <div class="col-4">
                <span class="bold">Comentarios<br>Crédito Y Riesgo</span>
            </div>
        </div>
            <div class="row">
                <div class="col-2">
                    <div class="text-blue">Comentarios<br>Carácter</div>
                    <div class="input">
                        <label>Comentarios</label>
                        <textarea readonly placeholder="comentarios" [(ngModel)]="ResolucionDatos.caracter_comentarios"></textarea>
                    </div>
                </div>
                <div class="col-2">
                    <div class="text-blue">Comentarios<br>Capacidad De Pago</div>
                    <div class="input">
                        <label>Comentarios</label>
                        <textarea readonly placeholder="comentarios" [(ngModel)]="ResolucionDatos.capacidad_pago_comentarios"></textarea>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-2">
                    <div class="text-blue">Comentarios<br>Colateral Y Condiciones</div>
                    <div class="input">
                        <label>Comentarios</label>
                        <textarea readonly placeholder="comentarios" [(ngModel)]="ResolucionDatos.colateral_comentarios"></textarea>
                    </div>
                </div>
                <div class="col-2" style="display: flex; justify-content: flex-end; align-items: flex-end;">
                    <span style="align-self: flex-end;" class="puntuacion small">{{ ResolucionDatos.puntuacion_total }} puntos</span>
                </div>
            </div>
            <div class="row">
                <div class="col-4">
                    <hr>
                </div>
            </div>

            <div class="row">
                <div class="col">
                    <div class="bold">Resolución<br>De Comité</div>
                </div>
            </div>

            <div class="row">
                <div >
                    <mat-radio-group [disabled]="sent" [(ngModel)]="Resolucion.id_resolucion" required >
                        <mat-radio-button labelPosition="before" class="space" [value]="1" [disabled]="!Aprobado || !documentosCompletos" >Aprobada</mat-radio-button>
                        <mat-radio-button labelPosition="before" class="space" [value]="3" >Información<br>Adicional</mat-radio-button>
                        <mat-radio-button labelPosition="before" [value]="2">Aprobada<br>Condicionalmente</mat-radio-button>
                        <mat-radio-button labelPosition="before" [value]="4" >Rechazada</mat-radio-button>
                    </mat-radio-group>
                    <mat-error *ngIf="submit && !Resolucion.id_resolucion">Campo obligatorio</mat-error>
                </div>
                <div class="col-2">
                    <div class="input">
                        <!-- <label>Comentarios</label> -->
                        <textarea maxlength="500" [disabled]="sent" placeholder="Comentarios" [(ngModel)]="Resolucion.comentarios"></textarea>
                        <mat-error *ngIf="submit && !Resolucion.comentarios">Campo obligatorio</mat-error>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-4 center-code">
                    <!-- <angular7-pincode
                        (currentIndex)="idx"
                        class="comite-code"
                        size="6"
                        (keydown)="onFullFill($event)"
                        (onFullFill)="onFullFill($event)">
                    </angular7-pincode> -->


                    <code-input 
                        [isCodeHidden]="false"
                        [isNonDigitsCode]="false"
                        [codeLength]="6"
                        (codeChanged)="onFullFill($event)"
                        (codeCompleted)="onFullFill($event)">
                    </code-input>
                    <div class="required" *ngIf="submitCode && code.length < 6" >Código invalido, vuelve a intentarlo.</div>
                    <span *ngIf="!loading">
                        <p *ngIf="sent == false" style="font-size: .9rem;"><a class="cursor-link" (click)="generateCode()">Enviar código</a></p>
                    </span>
                    <span *ngIf="loading">
                        <mat-spinner diameter="20"></mat-spinner>
                    </span>
                    <div *ngIf="sent == true" class="row">
                        <div class="col-1"></div>
                        <div class="col-1 text-center">
                            <a class="cursor-link" (click)="generateCode()">Reenviar código</a>
                        </div>
                        <div class="col-1 text-center">
                            <a class="cursor-link" (click)="cancelCode()">Cancelar código</a>
                        </div>
                        <div class="col-1"></div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col bold">
                    Participantes
                </div>
            </div>
            <div class="row">
                <div class="col-2">
                    <span class="text-blue">Participante 1</span>
                    <div class="input">
                        <label>Nombre del participante</label>
                        <app-selector-participantes (onSelect)="ParticipanteSeleccionado($event,'participante_uno')"></app-selector-participantes>
                        <input hidden="true" type="text" [(ngModel)]="Resolucion.participante_uno_nombre" [value]="suplente1 ? 'Daniel' : 'Alberto Gatica R.'  ">
                    </div>
                    <div class="input">
                        <label>Puesto</label>
                        <input readonly type="text"  [(ngModel)]="Resolucion.participante_uno_puesto">
                    </div>
                    <mat-checkbox (change)="checarParticipantes()" [disabled]="sent" [(ngModel)]="Resolucion.participante_uno">Asistencia del Participante</mat-checkbox>
                    <mat-error *ngIf="submit && !participantes">Campo obligatorio</mat-error>

                </div>
                <div class="col-2">
                    <span class="text-blue">Participante 2</span>
                <div class="input">
                    <label>Nombre del participante</label>
                    <app-selector-participantes (onSelect)="ParticipanteSeleccionado($event,'participante_dos')"></app-selector-participantes>
                    <input hidden="true" type="text" value="Ariel Fainsod Leff" [(ngModel)]="Resolucion.participante_dos_nombre" >
                </div>
                <div class="input">
                    <label>Puesto</label>
                    <input readonly type="text"  [(ngModel)]="Resolucion.participante_dos_puesto">
                </div>
                <mat-checkbox (change)="checarParticipantes()" [disabled]="sent" [(ngModel)]="Resolucion.participante_dos">Asistencia del Participante</mat-checkbox>
                <mat-error *ngIf="submit && !participantes">Campo obligatorio</mat-error>
                </div>
            </div>



            <div class="row">
                <div class="col-2">
                    <span class="text-blue">Participante 3</span>
                    <div class="input">
                        <label>Nombre del participante</label>
                        <app-selector-participantes (onSelect)="ParticipanteSeleccionado($event,'participante_tres')"></app-selector-participantes>
                        <input hidden="true" type="text" value="Jorge Dávila" [(ngModel)]="Resolucion.participante_tres_nombre">
                    </div>
                    <div class="input">
                        <label>Puesto</label>
                        <input  type="text" readonly [(ngModel)]="Resolucion.participante_tres_puesto" >
                    </div>
                    <mat-checkbox (change)="checarParticipantes()" [disabled]="false" [(ngModel)]="Resolucion.participante_tres">Asistencia del Participante</mat-checkbox>
                    <mat-error *ngIf="submit && !participantes">Campo obligatorio</mat-error>
                </div>
                <div class="col-2">
                    <span class="text-blue">Participante 4</span>
                <div class="input">
                    <label>Nombre del participante</label>
                    <app-selector-participantes (onSelect)="ParticipanteSeleccionado($event,'participante_cuatro')"></app-selector-participantes>
                    <input hidden="true" type="text" value="Lucero G. Martinez Orduñas" [(ngModel)]="Resolucion.participante_cuatro_nombre" >
                </div>
                <div class="input">
                    <label>Puesto</label>
                    <input   readonly type="text"  [(ngModel)]="Resolucion.participante_cuatro_puesto">
                </div>
                <mat-checkbox (change)="checarParticipantes()" [disabled]="false" [(ngModel)]="Resolucion.participante_cuatro">Asistencia del Participante</mat-checkbox>
                <mat-error *ngIf="submit && !participantes">Campo obligatorio</mat-error>
                </div>
            </div>
            <!-- <div class="row">
                <div class="col-4">
                    <hr>
                </div>
            </div>
            <div class="row">
                <div class="col-1">
                    <div class="input">
                        <mat-slide-toggle
                            labelPosition="before"
                            [(ngModel)]="additionalInformation">Información adicional</mat-slide-toggle>
                    </div>
                </div>
            </div>
             -->
    </div>
    <button mat-icon-button (click)="ActualizarComite()" >
        <svg  style="height: 60px; width:auto;" xmlns="http://www.w3.org/2000/svg" width="116.322" height="116.322" viewBox="0 0 116.322 116.322"><defs><style>.a{fill:#00a5da;}.b{fill:#fff;}</style></defs><g transform="translate(-902 -3389)"><g transform="translate(739 1848)"><path class="a" d="M58.161,0A58.161,58.161,0,1,1,0,58.161,58.161,58.161,0,0,1,58.161,0Z" transform="translate(163 1541)"/></g><g transform="translate(896.596 3947.768)"><path class="b" d="M41.4-500.669q0-10.725,0-21.45a5.963,5.963,0,0,1,4.633-6.142,6.565,6.565,0,0,1,1.48-.165q10.753-.015,21.506-.009a1.767,1.767,0,0,1,1.333.539q7.188,7.155,14.4,14.284a2.217,2.217,0,0,1,.688,1.678q0,11.805,0,23.611c0,3.1.011,6.208-.006,9.312a5.921,5.921,0,0,1-4.568,5.912,7.2,7.2,0,0,1-1.645.175q-15.825.016-31.649.008a5.957,5.957,0,0,1-6.169-6.137c-.014-6.374,0-12.748,0-19.122v-2.494Zm25.685-24.262c-.148-.019-.22-.036-.292-.036q-9.671,0-19.342,0A2.322,2.322,0,0,0,45-522.431q0,21.753,0,43.507a2.643,2.643,0,0,0,.1.761,2.374,2.374,0,0,0,2.567,1.667q12.553,0,25.106,0c2.18,0,4.36.008,6.54,0a2.2,2.2,0,0,0,2.425-2.341q0-15.435-.006-30.87c0-.179-.017-.357-.028-.579h-.917c-2.586,0-5.173.011-7.759,0a5.9,5.9,0,0,1-5.841-4.915,11.06,11.06,0,0,1-.1-1.819C67.083-519.649,67.089-522.271,67.089-524.931Zm3.577,2.755.11-.152c-.006.122-.016.243-.016.365,0,1.845-.008,3.69,0,5.535a2.4,2.4,0,0,0,2.662,2.675c1.79.01,3.579,0,5.369,0,.141,0,.282-.022.6-.049Z"/><path class="b" d="M112.862-402.662a20.413,20.413,0,0,1,3.467.541,5.619,5.619,0,0,1,3.76,6.088,5.838,5.838,0,0,1-4.969,5.135,34.168,34.168,0,0,1-4.2.1,1.094,1.094,0,0,1-1.112-1.2q-.012-4.652,0-9.3a1.129,1.129,0,0,1,1.259-1.22c.591-.008,1.182,0,1.772,0Zm-.617,2.613v6.977c.7,0,1.359.009,2.02,0a3.353,3.353,0,0,0,3.414-2.793,3.427,3.427,0,0,0-2.6-4A17.845,17.845,0,0,0,112.245-400.049Z" transform="translate(-51.359 -94.439)"/><path class="b" d="M73.008-401.922a31.835,31.835,0,0,1,4.288.037,3.9,3.9,0,0,1,3.213,4.357,3.981,3.981,0,0,1-3.85,3.59c-.419.019-.839,0-1.311,0v3.741h-2.34Zm2.355,5.573c.459,0,.863.011,1.266,0a1.572,1.572,0,0,0,1.533-1.394A1.558,1.558,0,0,0,77-399.417a9.164,9.164,0,0,0-1.641-.019Z" transform="translate(-23.73 -94.95)"/><path class="b" d="M164.64-402.1v2.4h-4.906v2.322h4.444V-395h-4.466v4.724h-2.38v-1.6q0-4.348,0-8.7c0-1.141.384-1.529,1.516-1.528C160.764-402.1,162.68-402.1,164.64-402.1Z" transform="translate(-87.046 -94.862)"/></g></g></svg>
    </button>
    <button class="next-button" mat-button (click)="Save()" >
        Siguiente
        <!-- <mat-icon>navigate_next</mat-icon> -->
        <svg style="height: 20px; width:auto;"  xmlns="http://www.w3.org/2000/svg" width="31.25" height="31.25" viewBox="0 0 31.25 31.25"><defs><style>.next{fill:#00a5da;}</style></defs><path class="next" d="M15.625,0A15.625,15.625,0,1,0,31.25,15.625,15.626,15.626,0,0,0,15.625,0Zm-1.3,24.74V12.173L8.755,17.741l-2.21-2.21,9.079-9.081,9.081,9.081-2.21,2.21-5.569-5.568V24.74Z" transform="translate(31.25) rotate(90)"/></svg>
    </button>

    <app-socials-footer style="width: 100%;"></app-socials-footer>
</div>